import React, { useEffect, useState } from "react";
import Select from "react-select";
import Toast from '../../../../Components/Toast/Toast'
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { ProjectNameDDL } from "../../../../Components/CommonDDL/ProjectNameDDL";
import { StateNameDDL } from "../../../../Components/CommonDDL/StateNameDDL";
import { RegionalOfficeNameDDL } from "../../../../Components/CommonDDL/RegionalOfficeNameDDL";
import { FieldStationOfficerDDL } from "../../../../Components/CommonDDL/FieldStationOfficerDDL";
import { DistrictDDL } from "../../../../Components/CommonDDL/DistrictDDL";
import { DefineProjectwisestateareaPopUpDeleteAPI, DefineProjectwisestateareaPostAPI, DefineProjectwisestateareaTableDataAPI } from "../../../../Helper/Redux/MasterSlice/DefineProjectWiseStateAreaSlice";
import { UnitNameDDL } from "../../../../Components/CommonDDL/UnitNameDDL";
import DeletePopUP from "../../../../Components/CommonPopUp/DeletePopUp";
import { AstricSign } from "../../../../Helper/AstricSign";
import { toastError } from "../../../../Helper/AlertMessage/AlertMessage";
import { RegExDecimalValue } from "../../../../Helper/regEx/RegExOnlyText";

export default function AddStateWiseProjectAreaPopUp(props) {

  const { handleShowAddModal, handleIsPost, ShowAddModal, From, IsPost, IsSearch, IsClear } = props
  const { flag, data } = ShowAddModal

  const userDetails = useAuthState();
  const { UserID, token } = userDetails
  const dispatch = useDispatch()

  const [ProjectArea, setProjectArea] = useState('')

  const [ProjectNameID, setProjectNameID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [StateID, setStateID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })
  const [RegionalOfficeID, setRegionalOfficeID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })

  const [FieldStationOfficerID, setFieldStationOfficerID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })

  const [DistrictID, setDistrictID] = useState({
    DDL: [],
    ID: 0,
    Label: "Select...",
  })

  const [RawData, setRawData] = useState([])
  const [UnitID, setUnitID] = useState('')
  const [UnitName, setUnitName] = useState('')
  const [PopUpGridData, setPopUpGridData] = useState([])
  const [IsTrue, setISTrue] = useState(false)

  const [GridObject, setGridObject] = useState({
    ProjectID: "0",
    ProjectName: "",
    StateID: "0",
    StateName: "",
    ROID: "0",
    ROName: "",
    FieldStationID: "0",
    FieldStationName: "",
    DistrictID: "0",
    DistrictName: "",
    ProjectArea: "",
    UnitID: "0",
    UnitName: ""

  })
  // console.log(GridData)
  // useEffect(() => {
  //   const data = {
  //     M_ProjectID: ProjectNameID.ID,
  //     M_StateNameID: StateID.ID,
  //     M_RegionalOfficeID: RegionalOfficeID.ID,
  //     M_FieldStationOfficerID: FieldStationOfficerID.ID,
  //     M_DistrictNameID: DistrictID.ID,
  //     M_TableUserMasterID: UserID,
  //     Flag: "Popup",
  //     FromTop: From,
  //     ToTop: '9999',
  //     token: token
  //   }
  //   dispatch(DefineProjectwisestateareaTableDataAPI({ data }))
  // }, [From, IsSearch, IsClear, IsPost])

  // const { isLoading, tableData } = useSelector(state => state.DefineProjectwisestateareaTableData)

  const handleObjectCreate = () => {
    const ObjectData = {
      ProjectID: ProjectNameID.ID,
      ProjectName: ProjectNameID.Label,
      StateID: StateID.ID,
      StateName: StateID.Label,
      ROID: RegionalOfficeID.ID,
      ROName: RegionalOfficeID.Label,
      FieldStationID: FieldStationOfficerID.ID,
      FieldStationName: FieldStationOfficerID.Label,
      DistrictID: DistrictID.ID,
      DistrictName: DistrictID.Label,
      ProjectArea: ProjectArea,
      UnitID: UnitID,
      UnitName: UnitName
    }

    const TempData = PopUpGridData.find((item) => {
      if (item.DistrictID == ObjectData.DistrictID) {
        return true
      } else {
        return false
      }
    }
    )

    if (TempData == null) {
      setPopUpGridData(data => [...data, ObjectData])
      handleExtractData(ObjectData)
      handleClear()
    } else {
      // handleClear()
      toastError("Record not exist")
    }

  }

  const handleExtractData = (ObjectData) => {
    // 'M_StateID|M_RegionalOfficeID|M_FieldStationOfficerID|M_DistrictID|ProjectArea|M_UnitID
    let allData = (ObjectData.StateID + '|' + ObjectData.ROID + '|' + ObjectData.FieldStationID + '|' + ObjectData.DistrictID + '|' + ObjectData.ProjectArea + '|' + ObjectData.UnitID)
    setRawData(data => [...data, allData])
  }


  const deleteTableRows = (index) => {
    const dataRows = [...PopUpGridData];
    dataRows.splice(index, 1);
    setPopUpGridData(dataRows);
  }


  const handleSubmit = () => {
    const data = {
      M_ProjectID: ProjectNameID.ID,
      RawData: RawData,
      M_TableUserMasterID: UserID,
      Flag: flag,
      token: token,
      handleIsPost
    }
    dispatch(DefineProjectwisestateareaPostAPI({ data }))
  }

  const { isPostLoading } = useSelector(state => state.DefineProjectwisestateareaPostData)

  const handleClear = () => {
    setProjectArea('')
    setUnitID('')
    setUnitName('')
    setStateID({
      ...StateID,
      ID: 0,
      Label: "Select...",
    })
    setRegionalOfficeID({
      ...RegionalOfficeID,
      ID: 0,
      Label: "Select...",
    })
    setFieldStationOfficerID({
      ...FieldStationOfficerID,
      ID: 0,
      Label: "Select...",
    })

  }

  const [IsValidDecimalNo, setIsValidDecimalNo] = useState(false)

  const handleCheckDecimalNumberOnly = (e) => {
    setProjectArea(e.target.value)
      const IsValidDecimalNo = RegExDecimalValue(e.target.value)
      setIsValidDecimalNo(IsValidDecimalNo)
      return IsValidDecimalNo
  }

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", backgroundColor: "#00000055" }}
      >
        <div className="modal-dialog add_popup modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header pl-4">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Define Project wise state area
              </h5>
              <button
                onClick={() => handleShowAddModal(false, '')}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body mx-4">
              <div className="row">
                <div className="col-lg-4">
                  <ProjectNameDDL
                    ProjectNameID={ProjectNameID}
                    setProjectNameID={setProjectNameID}
                    // DisableFlag="Add"
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag="AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <StateNameDDL
                    StateID={StateID}
                    setStateID={setStateID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag="AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <RegionalOfficeNameDDL
                    RegionalOfficeID={RegionalOfficeID}
                    setRegionalOfficeID={setRegionalOfficeID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    StateID={StateID}
                    AstricSignFlag="AstricSign"
                  />
                </div>
                <div className="col-xl-4 col-lg-4">
                  <FieldStationOfficerDDL
                    FieldStationOfficerID={FieldStationOfficerID}
                    setFieldStationOfficerID={setFieldStationOfficerID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    RegionalOfficeID={RegionalOfficeID}
                    AstricSignFlag="AstricSign"
                  />
                </div>
                <div className=" col-lg-4">
                  <DistrictDDL
                    DistrictID={DistrictID}
                    setDistrictID={setDistrictID}
                    StateID={StateID}
                    apiFlag='Master'
                    Flag={flag}
                    data={data}
                    IsPost=''
                    AstricSignFlag="AstricSign"
                  />
                </div>

                <div className="col-xl-4 col-lg-4">
                  {/* <div className="col-12 col-md-5"> */}
                  <div className="col-12">
                    <label for="exampleInputEmail1" className="form-label"> Project Area (Acres) <AstricSign /></label>
                  </div>
                  {/* </div> */}

                  <div className="col-12">
                    <div className="col-12">
                      <div className="input-group ">
                        <input
                          type="text"
                          className="form-control"
                          name="ProjectArea"
                          value={ProjectArea}

                          onChange={(e) => handleCheckDecimalNumberOnly(e)}
                        />
                      
                        <span className="input-group-text">
                          <UnitNameDDL
                            UnitID={UnitID}
                            setUnitID={setUnitID}
                            UnitName={UnitName}
                            setUnitName={setUnitName}
                            apiFlag='Master'
                            Flag={flag}
                            data={data}
                            IsPost=''
                            RegionalOfficeID={RegionalOfficeID}
                          />


                        </span>
                        {
                          IsValidDecimalNo && <text style={{ color: 'red' }}>Please enter Numbers only</text>
                        }

                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="form-group float-end mt-lg-3">

                    <button type="button" className="btn btn-outline-dark border-2 mx-2"
                      disabled={ProjectNameID.ID == 0 || StateID.ID == 0 || RegionalOfficeID.ID == 0 ||
                        FieldStationOfficerID.ID == 0 || DistrictID.ID == 0 || UnitID == 0 || ProjectArea == ""}
                      onClick={handleObjectCreate}> Add</button>

                    {/* <button type="button" className="btn btn-danger border-2"
                      onClick={handleClearCancel}>
                      {flag == 'Update' ? "Cancel" : "Clear"}
                    </button> */}
                  </div>
                </div>
              </div>
              <div className="table-responsive p-0 tableFixHead" >
                <table className="table table-bordered" >
                  <thead>
                    <tr className="bg-gradient-dark text-white">
                      <th style={{ width: "7%" }}>Sr. No.</th>
                      <th className=" ps-2"> State </th>
                      <th className=" ps-2"> Region Office </th>
                      <th className=" ps-2"> Field station </th>
                      <th className=" ps-2">District</th>
                      <th className=" ps-2"> Project Area(In Ha/Acres)</th>
                      <th style={{ width: "7%" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      PopUpGridData && PopUpGridData.length > 0 ? PopUpGridData.map((i, index) => {
                        return (
                          <>
                            <tr>
                              <td align="center">{index + 1}</td>

                              <td>{i.StateName ? i.StateName : '-'}</td>
                              <td>{i.ROName ? i.ROName : '-'}</td>
                              <td>{i.FieldStationName ? i.FieldStationName : '-'}</td>
                              <td>{i.DistrictName ? i.DistrictName : '-'}</td>
                              <td>{i.ProjectArea ? i.ProjectArea : '-'} {i.UnitName ? i.UnitName : '-'}</td>
                              <td align="center">

                                <i className="fa fa-trash mx-2 text-danger v_icon_style"
                                  onClick={() => deleteTableRows(index)}
                                  title="Delete"></i>
                              </td>
                            </tr>
                          </>
                        )
                      })
                        :
                        <tr>No data found ...</tr>
                    }
                  </tbody>
                </table>

              </div>
              <div className="col-12">
                <div className="form-group float-end ">

                  <button
                    type="button"
                    disabled={RawData.length <= 0}
                    className="btn btn-outline-dark border-2 mx-2"
                    data-ktwizard-type="action-next"
                    onClick={() => handleSubmit()}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    onClick={() => handleShowAddModal(false, '')}
                    className="btn btn-danger border-2"
                    data-ktwizard-type="action-next"
                  >
                    Cancel
                  </button>



                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
